export default "__VITE_ASSET__BCM05sld__"